import React from 'react';
import HeadersAuth from './HeadersAuth';

const PageLayout = ({ children }) => {
  const childrenArray = React.Children.toArray(children);
  const leftColumn = childrenArray[0];
  const rightColumn = childrenArray[1];

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-gray-900 to-black text-white relative">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black opacity-10 z-0 pointer-events-none"></div>

      {/* Fixed Header */}
      <HeadersAuth />

      {/* Main content wrapper with padding for fixed header */}
      <div className="flex flex-col flex-1 pt-[80px] z-10">
        <div className={`flex-1 w-full mx-auto gap-6 px-6 py-6 ${window.location.pathname === '/account' ? 'max-w-[1320px]' : 'max-w-screen-xl'}`}>
          {window.location.pathname === "/dashboard" ? (
            <div className="flex gap-6">
              <div className="flex-[6] bg-gray-800/70 rounded-lg p-5 border border-gray-700/30 overflow-auto">
                <div className="flex flex-col gap-4 w-full">{leftColumn}</div>
              </div>
              <div className="flex-[4] bg-gray-800/70 rounded-lg p-5 border border-gray-700/30 overflow-auto">
                <div className="flex flex-col gap-4 w-full">{rightColumn}</div>
              </div>
            </div>
          ) : window.location.pathname === '/account' ? (
            <div className="w-full">{leftColumn}</div>
          ) : (
            <div className="flex gap-6">
              <div className="flex-[10] bg-gray-800/70 rounded-lg p-5 border border-gray-700/30 overflow-auto">
                <div className="flex flex-col gap-4 w-full">{leftColumn}</div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        {/* <footer className="py-3 px-6 text-center text-gray-500 text-xs border-t border-gray-700/30 bg-black bg-opacity-50 z-10">
          <div className="max-h-[200px] overflow-auto">
            <p>
              The information contained on this website is solely for educational purposes, and does not constitute investment advice. The risk of trading in securities markets can be substantial. You must review and agree to our Disclaimers and Terms and Conditions before using this site.
              <br />
              U.S. Government Required Disclaimer - Commodity Futures Trading Commission. Futures and options trading has large potential rewards, but also large potential risk. You must be aware of the risks and be willing to accept them in order to invest in the futures and options markets. Don't trade with money you can't afford to lose. This website is neither a solicitation nor an offer to Buy/Sell futures or options. No representation is being made that any account will or is likely to achieve profits or losses similar to those discussed on this website.
              <br />
              © {new Date().getFullYear()} JTNC group. All rights reserved
            </p>
          </div>
        </footer> */}
      </div>
    </div>
  );
};

export default PageLayout;
